import { Config } from "./Config";

export class CombinationManager {
  constructor(board, pixiUi) {
    this.pixiUi = pixiUi;
    this.board = board;

    this.configInstace = new Config(pixiUi);
  }

  getMatches() {
    let result = [];

    this.board.fields.forEach((checkingField) => {
      this.configInstace.combinationRules.forEach((rule) => {
        let matches = [checkingField.tile];

        rule.forEach((position) => {
          const row = checkingField.row + position.row;
          const col = checkingField.col + position.col;
          const comparingField = this.board.getField(row, col);
          if (
            comparingField &&
            comparingField.tile.color === checkingField.tile.color
          ) {
            matches.push(comparingField.tile);
          }
        });

        if (matches.length === rule.length + 1) {
          result.push(matches);
        }
      });
    });
    return result;
  }
}
